import React, { useState } from 'react';
import { env } from '../lib/env';

const Diagnostics = () => {
  const [pingResult, setPingResult] = useState(null);
  const [formResult, setFormResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const testPing = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${env.apiBase}/ping`);
      const data = await response.json();
      setPingResult(data);
    } catch (error) {
      setPingResult({ error: error.message });
    }
    setLoading(false);
  };

  const testForm = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData(e.target);
    
    try {
      const response = await fetch(`${env.apiBase}/form`, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();
      setFormResult(data);
    } catch (error) {
      setFormResult({ error: error.message });
    }
    setLoading(false);
  };

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-8">Cloudflare Pages Diagnostics</h1>
      
      <div className="grid gap-8 md:grid-cols-2">
        {/* Ping Test */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">API Ping Test</h2>
          <button
            onClick={testPing}
            disabled={loading}
            className="bg-blue-500 hover:bg-blue-600 disabled:opacity-50 text-white px-4 py-2 rounded mb-4"
          >
            {loading ? 'Testing...' : 'Test /api/ping'}
          </button>
          
          {pingResult && (
            <div className="bg-gray-100 rounded p-4">
              <pre className="text-sm overflow-auto">
                {JSON.stringify(pingResult, null, 2)}
              </pre>
            </div>
          )}
        </div>

        {/* Form Test */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold mb-4">Form Endpoint Test</h2>
          <form onSubmit={testForm} className="space-y-4">
            <input
              type="text"
              name="name"
              placeholder="Name"
              className="w-full border rounded px-3 py-2"
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              required
              className="w-full border rounded px-3 py-2"
            />
            <textarea
              name="message"
              placeholder="Message"
              required
              className="w-full border rounded px-3 py-2"
              rows="3"
            ></textarea>
            <button
              type="submit"
              disabled={loading}
              className="bg-green-500 hover:bg-green-600 disabled:opacity-50 text-white px-4 py-2 rounded"
            >
              {loading ? 'Submitting...' : 'Test Form Submit'}
            </button>
          </form>
          
          {formResult && (
            <div className="bg-gray-100 rounded p-4 mt-4">
              <pre className="text-sm overflow-auto">
                {JSON.stringify(formResult, null, 2)}
              </pre>
            </div>
          )}
        </div>
      </div>

      <div className="mt-8 bg-yellow-50 border-l-4 border-yellow-400 p-4">
        <h3 className="font-semibold">Environment Info</h3>
        <p>Stage: {env.stage}</p>
        <p>API Base: {env.apiBase}</p>
        <p>Hostname: {location.hostname}</p>
      </div>
    </div>
  );
};

export default Diagnostics;